import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Facture from '../../../Components/Docs/Facture';
import FactureG from '../../../Components/Docs/FactureG';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import {statutPaiementEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getLastWorkingDayOfMonth } from '../../../Utils/getCalendarMonthMatrix';
import { extractYearAndMonth, getNomPrenomClearFromPersoData, isFactureG, searchLabelInEnumByValue, sortDate, UpperCasePrenomNom } from '../../../Utils/utils';
import { getMontatantTTC } from '../../../Utils/utilsCraX';
import HeaderAllFacture from '../../Expert/Mission/HeaderAllFacture';

const AllFactureClient = () => {
    const { addEuro4Decimal } = useNumberFormatting();

    const { setBackdropOpen} = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const [factureRows, setFactureRows] = useState([]);
    const [rowselected, setRowSelected] = useState();
    const [open, setOpen] = useState(false);
    const [openFactureG, setOpenFactureG] = useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const role=useRole();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [filtreFactureClientNonPaye, setFiltreFactureClientNonPaye] = useState(searchParams.get('filtreFactureClientNonPaye') === 'true');
    const { i18n } = useTranslation();
    const factureColumns4Client = [
        {
            field: 'refFactureClient',
            title: i18n.t('Réf. Facture'),
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateEmission),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
        },
        {
            field: 'refCra',
            title: i18n.t('Réf.CRA'),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutPaiementClient',
            title: i18n.t('Statut paiement'),
            render:  rowData =>{
                if(rowData?.Statut!='groupe')
                    return i18n.t(searchLabelInEnumByValue(statutPaiementEnum,rowData?.statutPaimentClient));
            }
        },
        {
            field: 'datePaiementClient',
            title: i18n.t('Date Paiement/Client'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementClient)
        },
        {
            field: 'periode',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.periode)),
        },
        {
            field: 'dateEcheance',
            title: i18n.t('Date d\'échéance'),
        },
        {
            field: 'nbJour',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'tjClientHt',
            title: i18n.t('Taux journalier HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjClientHt)
        },
        {
            field: 'totalHTClient',
            title: i18n.t('Total HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHTClient)
        },
        {
            field: 'tvaClient',
            title: i18n.t('TVA appliquée'),
            render: rowData => {
                return addEuro4Decimal(rowData?.tvaClient,' %');
            }
        },
        {
            field: 'totalTTCClient',
            title: i18n.t('Total TTC'),
            render:  rowData =>{
                if(isFactureG(rowData?.refFacture))
                    return addEuro4Decimal(rowData?.totalTTCClient);
                return addEuro4Decimal(getMontatantTTC(rowData?.totalHTClient, rowData?.tvaClient));
            }
        },
        {
            field: 'respOperationnel',
            title: i18n.t('Resp.Opérationnel'),
        },
        {
            field: 'respAchat',
            title: i18n.t('Resp.Achat'),
        },
        {
            field: 'respComptabilite',
            title: i18n.t('Resp.Comptabilité'),
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
    ];

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrefactureclientnonpaye')){
            setFiltreFactureClientNonPaye(false);
        }
    }, [url]);

    useEffect(() => {
        getMyFactures();
    }, [filtreFactureClientNonPaye]);

    useEffect(() => {
        getMyFactures();
    }, []);

    //=============================================================================

    const mapFacturesG = (facture) => {
        // const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
        // /** @aida
        //      *//* start working firstly on the normal situation (before adding the filetrs),
        //      *here is the structure of a factureG:{
        //                 companyDataId
        //                 refCmdClient
        //                 factures : dedant tu va trouve leur cra
        //                 facturesX : dedant tu va trouve leur craX
        //                 refFacture
        //                 dateEmission
        //                 statutFactureG
        //                 // ! add a verification layer after your own calcul based on those totals (total calculee == total sauvegardee)
        //                 totalClient,
        //                 totalExpert,
        // */
        const factureG = facture?.factures?.length >0 ? facture?.factures[0]?.['craId'] : facture?.facturesX[0]?.['craXId'];
        console.log('factureG',factureG);
        const periodeFactureG = extractYearAndMonth(facture?.refFacture);
        return {
            'id': facture?._id,
            'refFactureClient': facture?.refFacture,
            'refFactureExpert':facture?.refFacture + 'E',
            'refCra': '--',
            'nomExpert': '--',
            'intituleMission': '--',
            'dateValidationCra': '--',
            'dateEmission': formatDateJJMMYYYY(facture?.dateEmission),
            'Date':facture?.dateEmission,
            'Statut': 'groupeG',
            'periode':dayjs(new Date(periodeFactureG?.year, periodeFactureG?.month-1)).locale('fr').format('MMMM YYYY'),
            'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(periodeFactureG?.year,  periodeFactureG?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(periodeFactureG?.year,  periodeFactureG?.month-1)).locale('fr').format('MM'),
                (facture?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',facture?.delaiPaiement)),
            'statutPaiementClient':facture?.statutPaimentClient,
            'datePaiementClient':facture?.datePaimentClient,
            'nbJour':'--',
            'tjClientHt':'--',
            'totalHTClient':facture?.totalHtClient,
            'tvaClient':facture?.tvaClient,
            'totalTTCClient':facture?.totalClient,
            'hnos':'--',
            'astreintes':'--',
            'notesFrais':'--',
            'totalAstreinte':'--',
            'totalHnoClient':'--',
            'totalHnoExpert': '--',
            'totalNotesFrais':'--',
            'respComptabilite':getNomPrenomClearFromPersoData(factureG?.bdcId?.responsableComptabiliteId?.persoData ?? factureG?.bdcId?.responsableComptabiliteEsnExpertId?.persoData),
            'respOperationnel': '--', //getNomPrenomClearFromPersoData(factureG?.bdcId?.responsableOperationnelId?.persoData),
            'respAchat':getNomPrenomClearFromPersoData(factureG?.bdcId?.responsableAchatId?.persoData ?? factureG?.bdcId?.responsableAchatEsnId?.persoData),
            'chargeRecrutement':getNomPrenomClearFromPersoData(factureG?.bdcId?.backOfficeId?.persoData),
            ...facture
        };

    };

    const mapFactures = (facture) => {
        const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
        return {
            isCraOrCraX,
            'id': facture?._id,
            //'refFactureClient': facture?.craId?.nbrDays ? facture?.factureId : facture?.factureXId,
            'refFactureClient': facture?.refFacture ?  (facture?.statutFacture =='groupe' ? 'P'+facture?.refFacture: facture?.refFacture) :'Proforma client',
            'refFactureExpert':!facture?.refFacture ? facture?.refFacture + 'E':'Proforma expert',
            //'refFactureExpert': facture?.craId?.nbrDays ? facture?.factureId + 'E' : facture?.factureXId + 'E',
            'refCra': facture?.[isCraOrCraX]?.[isCraOrCraX],
            'nomExpert': UpperCasePrenomNom(facture?.[isCraOrCraX]?.missionId?.expertId?.persoData),
            'intituleMission': facture?.[isCraOrCraX]?.missionId?.titre,
            'dateValidationCra': Date(facture?.[isCraOrCraX]?.DateVC) > Date(facture?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVE),
            'dateEmission': formatDateJJMMYYYY(facture?.dateEmission),
            'Date':facture?.dateEmission,
            'Statut': facture?.craId?.nbrDays ? facture?.statutFacture : facture?.statutFactureX,
            //'periode':facture?.[isCraOrCraX]?.month,
            'periode':
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY')
            ,
            'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                (facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',facture?.delaiPaiement)),
            //'dateEcheance':formatDateJJMMYYYY(moment(facture?.dateEmission).add('days', facture?.delaiPaiement)),
            'statutPaiementClient': facture?.statutPaimentClient,
            'datePaiementClient':facture?.datePaimentClient,
            'nbJour':facture?.craId?.nbrDays,
            'tjClientHt':facture?.[isCraOrCraX]?.tjClient,
            'tvaClient':facture?.tvaClient ?? facture?.[isCraOrCraX]?.missionId?.esnId?.donneeFacturation?.tauxTva ?? facture?.[isCraOrCraX]?.missionId?.companyDataId?.donneeFacturation?.tauxTva,
            'hnos':facture?.[isCraOrCraX]?.hnos,
            'astreintes':facture?.[isCraOrCraX]?.astreintes,
            'notesFrais':facture?.[isCraOrCraX]?.notesFrais,
            'totalAstreinte':addEuro4Decimal(facture?.craXId?.totalAstreintes),
            'totalHnoClient':addEuro4Decimal(facture?.craXId?.totalHnosClient),
            'totalHnoExpert': addEuro4Decimal(facture?.craXId?.totalHnos),
            'totalNotesFrais': addEuro4Decimal(facture?.craXId?.totalNotesFrais),
            'totalHTClient':facture?.[isCraOrCraX]?.nbrDays ?(facture?.[isCraOrCraX]?.nbrDays * facture?.[isCraOrCraX]?.tjClient): facture?.[isCraOrCraX]?.montantTotalClient,
            'respComptabilite':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableComptabiliteId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableComptabiliteEsnId?.persoData),
            'respOperationnel':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
            'respAchat':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableAchatId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableAchatEsnId?.persoData),
            'chargeRecrutement':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
            ...facture
        };
    };
    const getMyFactures = async () => {
        setBackdropOpen(true);
        const endpoint = role === 'esn'
            ? '/facture/getMyFactures/'
            : '/facture/getMyFactures/?isAchat=true';
        try {
            const response = await axiosPrivate.get(endpoint);
            let listFacture = await response.data?.factures;
            let Array1=[];
            if(filtreFactureClientNonPaye){
                Array1 = listFacture.reduce((acc, facture) => {
                    console.log('facture?.refFacture',facture?.refFacture);
                    const isFactureOrG = isFactureG(facture?.refFacture);
                    if(!isFactureOrG && (facture?.statutFacture=='genere')&&(facture?.statutPaimentClient=='nonPaye'||facture?.statutPaimentExpert=='nonPaye'))
                        acc.push(mapFactures(facture));
                    if(isFactureOrG && facture?.statutFactureX=='genere' &&(facture?.statutPaimentClient=='nonPaye'||facture?.statutPaimentExpert=='nonPaye') ){
                        acc.push(mapFacturesG(facture));
                    }

                    return acc;
                }, []);
            }
            else{
                Array1 = listFacture.reduce((acc, facture) => {
                    const isFactureOrG = isFactureG(facture?.refFacture);
                    if(isFactureOrG)
                        acc.push(mapFacturesG(facture));
                    else
                        acc.push(mapFactures(facture));

                    return acc;
                }, []);
            }
            setFactureRows(sortDate(Array1));
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            {/* <div className='frame5Profile'>
                {i18n.t('CRA & Factures')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
            </div> */}
            <div className='frame5Profile'>
                {i18n.t('CRA & Factures')}
                {role === 'esn' && (
                    <>
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Achat')}</span>
                    </>
                )}
                &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
            </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Factures')}
                </h4>
                <HeaderAllFacture />
                <MaterialTableComponent
                    title="Factures"
                    data={factureRows}
                    columns={factureColumns4Client}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        setRowSelected(rowData);
                        if(isFactureG(rowData.refFacture))
                            setOpenFactureG(true);
                        else
                            setOpen(true);
                    }}
                    selectedRow={selectedRow}
                />
            </div>
            {open &&
            <Facture
                handleClose={()=>{
                    setOpen(false);
                }}
                facture={rowselected}
                open={open}
                role={'client'}
            />}

            {openFactureG &&
            <FactureG
                handleClose={()=>{
                    setOpenFactureG(false);
                }}
                facture={rowselected}
                open={openFactureG}
                role={'client'}
            />}
        </>
    );
};

export default AllFactureClient;
